import { ErrorResponse } from '@partnerconnect-monorepo/types/ErrorResponse';
import { InfoBanner } from '@partnerconnect-monorepo/types/info-banner/InfoBanner';
import { axios } from '../../lib/core/AxiosInterceptor/AxiosInterceptor';
import { mapToCamelCase } from '../../lib/helpers/helpers';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';

const getPartnershipsInfoBanner = () =>
  axios
    .get(`${import.meta.env.VITE_FLA_APP_BE_BASE}/profile/infobanner`)
    .then<Array<InfoBanner>>((res) => mapToCamelCase(res.data))
    .catch(() => []);

export const usePartnershipsInfoBanner = (
  options: Partial<
    UseQueryOptions<
      Array<InfoBanner>,
      AxiosError<ErrorResponse>,
      Array<InfoBanner>,
      [string]
    >
  > = {}
) =>
  useQuery({
    queryKey: ['PARTNERSHIPS_INFOBANNER'],
    queryFn: getPartnershipsInfoBanner,
    ...options
  });
